import * as React from "react";
type Props = {
  className?: string,
};
function SvgLunch({ className }: Props) {
  return (
    <svg
      viewBox="0 0 36 37"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Lunch"
      className={className}
    >
      <path
        d="M31.8501 27.11C31.4701 27.81 30.7201 28.26 30.4701 28.4C29.0801 29.17 27.4301 28.99 25.8701 28.8C18.7801 27.95 16.8801 27.37 13.8501 27.54C12.2501 27.63 10.8801 27.7 9.35006 28.35C8.40006 28.75 8.09006 29.08 7.20006 29.22C5.93006 29.43 4.26006 29.15 3.37006 28.28C3.10006 28.01 2.91006 27.71 2.79006 27.39C1.38006 28.27 0.560059 29.28 0.560059 30.36C0.560059 33.68 8.17006 36.37 17.5601 36.37C26.9501 36.37 34.5601 33.68 34.5601 30.36C34.5601 29.17 33.5601 28.05 31.8501 27.11Z"
        fill="#F1F6F9"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M31.0899 24.51C30.8099 24.26 30.2499 23.84 28.9299 23.49C28.8699 23.55 28.8099 23.6 28.7499 23.65L28.7399 23.66C28.6799 23.71 28.6199 23.76 28.5699 23.81C28.4799 23.88 28.4099 23.94 28.3299 24C28.2099 24.09 28.1099 24.16 28.0499 24.2C28.0499 24.2 28.0399 24.2 28.0399 24.21C28.0199 24.23 27.9999 24.24 27.9899 24.25C27.9799 24.26 27.9699 24.26 27.9699 24.26C27.9499 24.28 27.9199 24.31 27.8799 24.34C27.8699 24.35 27.8599 24.35 27.8499 24.36C27.7699 24.42 27.6699 24.48 27.5499 24.55C27.5299 24.56 27.5199 24.57 27.4999 24.58C27.4399 24.61 27.3799 24.65 27.3199 24.68C27.2199 24.73 27.1299 24.78 27.0299 24.83C26.9799 24.85 26.9299 24.88 26.8799 24.9C26.8399 24.92 26.7899 24.94 26.7499 24.96C26.7299 24.97 26.7199 24.98 26.6999 24.98C26.6799 24.99 26.6499 25 26.6299 25.01C26.6099 25.02 26.5899 25.03 26.5799 25.03C26.5599 25.04 26.5399 25.05 26.5299 25.05C26.5099 25.06 26.4899 25.07 26.4799 25.07C26.4699 25.08 26.4599 25.08 26.4399 25.09C26.4199 25.1 26.3999 25.11 26.3899 25.11C26.3899 25.11 26.3799 25.11 26.3799 25.12C26.3199 25.15 26.2799 25.16 26.2799 25.16C26.0899 25.24 25.8899 25.31 25.6999 25.36C25.2999 25.47 24.8999 25.55 24.5299 25.59C24.2499 25.62 23.9899 25.64 23.7599 25.65C23.6799 25.65 23.6099 25.66 23.5399 25.66C23.4799 25.66 23.4199 25.66 23.3599 25.66C23.3399 25.66 23.3299 25.66 23.3099 25.66C23.2699 25.66 23.2299 25.66 23.1999 25.66C23.1899 25.66 23.1699 25.66 23.1599 25.66C23.0699 25.66 22.9999 25.66 22.9499 25.65C22.9399 25.65 22.9399 25.65 22.9299 25.65C22.9099 25.65 22.8999 25.65 22.8899 25.65H22.8799C22.8699 25.65 22.8599 25.65 22.8599 25.65C22.7299 25.64 22.5999 25.62 22.4799 25.6C22.2299 25.56 21.9899 25.51 21.7699 25.45C20.7299 25.18 19.9399 24.72 19.5699 24.47C19.5499 24.46 19.5399 24.45 19.5299 24.44C19.4999 24.42 19.4699 24.4 19.4499 24.38C19.4399 24.37 19.4299 24.36 19.4199 24.36C19.3999 24.35 19.3799 24.33 19.3699 24.32C19.3599 24.31 19.3599 24.31 19.3499 24.31C19.3399 24.3 19.3299 24.29 19.3299 24.29C19.1899 24.21 19.0599 24.11 18.9299 24C18.6899 23.81 18.4599 23.58 18.2399 23.35C18.2299 23.34 18.2099 23.32 18.1999 23.31C18.1099 23.21 18.0299 23.12 17.9399 23.02C17.9199 23 17.9099 22.99 17.8999 22.97C17.8199 22.88 17.7499 22.79 17.6799 22.7C17.6699 22.69 17.6599 22.67 17.6499 22.66C17.5299 22.51 17.4299 22.37 17.3499 22.26C17.3399 22.24 17.3299 22.23 17.3199 22.22C17.2999 22.19 17.2799 22.17 17.2699 22.14C17.2599 22.13 17.2499 22.12 17.2499 22.1C17.2399 22.08 17.2299 22.07 17.2199 22.05C17.2099 22.04 17.2099 22.04 17.2099 22.03C17.1999 22.02 17.1999 22.01 17.1999 22.01L17.2299 21.94C17.1999 21.94 17.1799 21.94 17.1499 21.94C16.9499 22.24 16.7799 22.47 16.7799 22.47C16.4699 22.96 15.6499 23.69 15.6499 23.69C14.6199 24.62 13.4699 24.99 13.4699 24.99C12.1299 25.51 10.7799 25.28 10.7799 25.28C8.8399 25.08 7.2999 23.59 6.7099 22.94C6.1099 22.92 5.3399 22.96 4.6299 23.32C2.9399 24.19 1.8899 26.74 3.4299 28.25C4.3199 29.12 5.9899 29.4 7.2599 29.19C8.1499 29.04 8.4499 28.72 9.4099 28.32C10.9399 27.67 12.3099 27.6 13.9099 27.51C16.9399 27.34 18.8399 27.92 25.9299 28.77C27.4899 28.96 29.1399 29.14 30.5299 28.37C30.8599 28.19 32.0799 27.45 32.1299 26.3C32.1099 25.42 31.3799 24.77 31.0899 24.51Z"
        fill="#9E6D00"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M13.0303 25.15C13.4003 25.44 14.4703 25.56 15.4303 27.57"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M26.03 28.71C26.02 28.73 26.29 28.11 23.73 25.67"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M30.5098 15.89C31.7998 16.35 33.7698 17.41 33.3398 19.63C32.8098 22.38 28.7898 18.53 27.3298 19.01C26.5498 19.27 26.3498 20.25 25.6898 20.76C24.6598 21.56 23.7698 21.09 22.7098 20.54C20.9298 19.62 19.1298 17.67 17.1598 18.71C15.4698 19.61 14.7598 21.94 12.6998 21.11C11.1698 20.49 10.0698 18.08 8.28982 18.57C6.91982 18.95 5.58982 21.16 4.06982 20.17"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M4.56984 23.35C2.87984 24.22 1.82984 26.77 3.36984 28.28C4.25984 29.15 5.92984 29.43 7.19984 29.22"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M15.8101 23.53C15.8101 23.53 20.3001 25.67 20.7101 28.13"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M3.43018 24.31C3.43018 24.31 7.79018 25.29 10.5902 27.95"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M30.5403 28.36C30.5403 28.39 29.8703 26.77 27.3003 24.68"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M25.8603 28.8C18.7703 27.95 16.8703 27.37 13.8403 27.54C12.2403 27.63 10.8703 27.7 9.34027 28.35C8.39027 28.75 8.08027 29.08 7.19027 29.22C6.64027 29.31 6.02027 29.3 5.41027 29.2C5.39027 30.33 5.87027 31.49 6.83027 31.67C9.49027 32.17 9.98027 32.09 12.4703 31.89C14.6103 31.72 16.8303 31.75 18.9803 31.75C20.6003 31.75 22.2003 31.71 23.8203 31.73C25.4503 31.74 26.5203 31.62 28.0103 31.57C28.7603 31.55 30.0503 31.28 30.2603 29.72C30.3203 29.23 30.3203 28.82 30.2603 28.48C28.9303 29.14 27.3603 28.98 25.8603 28.8Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M4.91016 18.8L6.60016 21.61L17.7202 21.18L21.4402 24.51L27.9602 23.67L29.8402 20.79L28.0902 18.01L4.91016 18.8Z"
        fill="#D2451E"
      />
      <path
        d="M27.3299 19C26.7699 19.18 26.4199 19.79 26.4199 19.79C26.2799 20.03 26.3499 20.36 26.5799 20.52L27.7899 21.39C28.0099 21.55 28.2799 21.78 28.3899 21.9C28.3899 21.9 28.3899 21.9 28.3999 22.17C28.4099 22.44 28.4099 22.44 28.4099 22.44C28.3099 22.56 28.0399 22.78 27.8099 22.94C27.8099 22.94 25.9699 24.15 25.1399 23.99C24.7199 23.91 24.7199 23.91 24.7199 23.91C24.7099 23.75 24.6799 23.39 24.6499 23.11L24.5299 21.67C24.5199 21.39 24.2899 21.11 24.0199 21.04L23.3699 20.84C23.1199 20.72 22.8899 20.84 22.8599 21.12L22.6499 22.95C22.6199 23.23 22.5499 23.57 22.4999 23.72C22.4999 23.72 22.4999 23.72 22.2699 23.85C22.0199 24 22.0199 24 22.0199 24C21.8699 23.97 21.5499 23.83 21.3099 23.69C21.3099 23.69 19.3999 22.61 19.1299 21.79C18.9999 21.37 18.9999 21.37 18.9999 21.37C19.1399 21.29 19.4299 21.09 19.6599 20.93L21.0199 20.03C21.2599 19.88 21.2599 19.64 21.0299 19.49C21.0299 19.49 19.1099 18.21 17.8699 18.46C18.0899 18.42 18.0899 18.42 18.0899 18.42C18.3199 18.42 18.4599 18.64 18.3899 18.91C18.3899 18.91 17.9799 20.51 17.3099 21.65C17.2399 21.76 17.2399 21.76 17.2399 21.76C17.1599 21.88 17.1399 22.05 17.1999 22.14C17.1999 22.14 17.1999 22.14 17.2599 22.22C17.7499 22.93 19.5699 25.35 22.8399 25.66C25.6199 25.92 28.2799 24.55 29.8399 22.42C30.3799 21.68 30.7699 20.74 30.7699 20.74C30.8799 20.48 30.7599 20.17 30.5199 20.03C30.5099 20.04 28.1099 18.75 27.3299 19Z"
        fill="#D2451E"
      />
      <path
        d="M27.3299 19C26.7699 19.18 26.4199 19.79 26.4199 19.79C26.2799 20.03 26.3499 20.36 26.5799 20.52L27.7899 21.39C28.0099 21.55 28.2799 21.78 28.3899 21.9C28.3999 22.17 28.4099 22.44 28.4099 22.44C28.3099 22.56 28.0399 22.78 27.8099 22.94C27.8099 22.94 25.9699 24.15 25.1399 23.99C25.1299 23.83 24.6799 23.39 24.6499 23.11L24.5299 21.67C24.5199 21.39 24.2899 21.11 24.0199 21.04L23.3699 20.84C23.1199 20.72 22.8899 20.84 22.8599 21.12L22.6499 22.95C22.6199 23.23 22.5499 23.57 22.4999 23.72L22.2699 23.85C22.1199 23.82 21.5499 23.83 21.3099 23.69C21.3099 23.69 19.2699 22.19 18.9999 21.37C19.1399 21.29 19.4299 21.09 19.6599 20.93L21.0199 20.03C21.2599 19.88 21.2599 19.64 21.0299 19.49C21.0299 19.49 19.1099 18.21 17.8699 18.46C18.0899 18.42 18.0899 18.42 18.0899 18.42C18.3199 18.42 18.4599 18.64 18.3899 18.91C18.3899 18.91 17.9799 20.51 17.3099 21.65C17.2399 21.76 17.2399 21.76 17.2399 21.76C17.1599 21.88 17.1399 22.05 17.1999 22.14C17.1999 22.14 17.1999 22.14 17.2599 22.22C17.7499 22.93 19.5699 25.35 22.8399 25.66C25.6199 25.92 28.2799 24.55 29.8399 22.42C30.3799 21.68 30.7699 20.74 30.7699 20.74C30.8799 20.48 30.7599 20.17 30.5199 20.03C30.5099 20.04 28.1099 18.75 27.3299 19Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M18.45 3.89001C18.68 3.75001 18.72 3.45001 18.54 3.24001C18.36 3.03001 18.32 2.70001 18.44 2.50001C18.56 2.31001 18.51 2.15001 18.31 2.15001C18.12 2.15001 17.96 2.08001 17.96 2.00001C17.96 1.92001 17.92 1.76001 17.87 1.65001C17.82 1.54001 17.53 1.45001 17.5 1.45001C17.47 1.45001 17.34 1.49001 17.23 1.54001C17.12 1.59001 17.03 1.92001 17.03 2.00001C17.03 2.08001 16.87 2.15001 16.68 2.15001C16.49 2.15001 16.44 2.31001 16.57 2.50001C16.7 2.69001 16.64 3.03001 16.43 3.25001C16.22 3.47001 16.22 3.76001 16.43 3.90001C16.64 4.04001 16.75 4.38001 16.69 4.65001C16.62 4.93001 16.94 5.15001 17.41 5.15001C17.88 5.15001 18.2 4.92001 18.14 4.65001C18.09 4.38001 18.23 4.03001 18.45 3.89001Z"
        fill="#EDAB93"
      />
      <path
        d="M18.45 3.89001C18.68 3.75001 18.72 3.45001 18.54 3.24001C18.36 3.03001 18.32 2.70001 18.44 2.50001C18.56 2.31001 18.51 2.15001 18.31 2.15001C18.12 2.15001 17.96 2.08001 17.96 2.00001C17.96 1.92001 17.92 1.76001 17.87 1.65001C17.82 1.54001 17.53 1.45001 17.5 1.45001C17.47 1.45001 17.34 1.49001 17.23 1.54001C17.12 1.59001 17.03 1.92001 17.03 2.00001C17.03 2.08001 16.87 2.15001 16.68 2.15001C16.49 2.15001 16.44 2.31001 16.57 2.50001C16.7 2.69001 16.64 3.03001 16.43 3.25001C16.22 3.47001 16.22 3.76001 16.43 3.90001C16.64 4.04001 16.75 4.38001 16.69 4.65001C16.62 4.93001 16.94 5.15001 17.41 5.15001C17.88 5.15001 18.2 4.92001 18.14 4.65001C18.09 4.38001 18.23 4.03001 18.45 3.89001Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M5.08008 20.39C5.08008 20.39 5.59008 22.39 7.95008 24.16C7.95008 24.16 10.3401 26.33 13.8701 24.82C13.8701 24.82 15.6101 24.15 16.9701 22.13C16.9701 22.13 17.7201 21.34 18.4901 18.4"
        fill="#D2451E"
      />
      <path
        d="M5.08008 20.39C5.08008 20.39 5.59008 22.39 7.95008 24.16C7.95008 24.16 10.3401 26.33 13.8701 24.82C13.8701 24.82 15.6101 24.15 16.9701 22.13C16.9701 22.13 17.7201 21.34 18.4901 18.4"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M10.1603 19.06C10.1603 19.06 7.69028 20.4 7.51028 20.65C7.51028 20.65 7.11028 20.96 7.60028 21.53C7.60028 21.53 8.54028 22.53 9.87028 23.28C9.87028 23.28 10.5303 23.41 10.6003 22.84L10.8103 19.61"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M12.0601 20.73C12.0601 20.73 12.1401 22.62 12.2401 22.97C12.2401 22.97 12.3401 23.36 12.8301 23.32C12.8301 23.32 13.6901 23.22 15.2701 21.89C15.2701 21.89 15.7701 21.24 14.9801 20.63"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M29.9899 15.89C31.2799 16.35 33.7699 17.41 33.3399 19.63C32.8099 22.38 28.7899 18.53 27.3299 19.01C26.5499 19.27 26.3499 20.25 25.6899 20.76C24.6599 21.56 23.7699 21.09 22.7099 20.54C20.9299 19.62 19.1299 17.67 17.1599 18.71C15.4699 19.61 14.7599 21.94 12.6999 21.11C11.1699 20.49 10.0699 18.08 8.28992 18.57C6.91992 18.95 5.58992 21.16 4.06992 20.17C1.73992 18.64 5.56992 16 6.50992 15.54"
        fill="#C2DA96"
      />
      <path
        d="M29.9899 15.89C31.2799 16.35 33.7699 17.41 33.3399 19.63C32.8099 22.38 28.7899 18.53 27.3299 19.01C26.5499 19.27 26.3499 20.25 25.6899 20.76C24.6599 21.56 23.7699 21.09 22.7099 20.54C20.9299 19.62 19.1299 17.67 17.1599 18.71C15.4699 19.61 14.7599 21.94 12.6999 21.11C11.1699 20.49 10.0699 18.08 8.28992 18.57C6.91992 18.95 5.58992 21.16 4.06992 20.17C1.73992 18.64 5.56992 16 6.50992 15.54"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M19.7803 24.64C19.8603 24.69 19.9503 24.74 20.0403 24.79"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M6.43998 12.88C6.43998 12.88 6.22998 13.65 5.97998 14.6C5.72998 15.55 7.31998 16.35 9.51998 16.4L26.91 16.74C29.11 16.78 30.65 16.12 30.33 15.26C30.01 14.4 29.75 13.7 29.75 13.7"
        fill="#F0CA9E"
      />
      <path
        d="M6.43998 12.88C6.43998 12.88 6.22998 13.65 5.97998 14.6C5.72998 15.55 7.31998 16.35 9.51998 16.4L26.91 16.74C29.11 16.78 30.65 16.12 30.33 15.26C30.01 14.4 29.75 13.7 29.75 13.7"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M29.9802 13.41C30.2902 11.9 24.3002 9.68003 23.3002 9.28003C18.9502 7.54003 13.5902 7.05003 9.37021 9.46003C8.51021 9.95003 6.95021 10.81 6.44021 11.84C5.90021 12.92 6.98021 13.19 7.80021 13.3C8.85021 13.45 9.93021 13.43 10.9802 13.48C14.3202 13.66 17.6702 13.83 21.0102 13.94C22.7602 14 24.5102 14.04 26.2602 14.03C26.8102 14.02 29.8102 14.27 29.9802 13.41Z"
        fill="#F0CA9E"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M17.4702 9.13V5.16"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M19.4899 24.46C19.4999 24.47 19.5199 24.48 19.5299 24.49C19.5899 24.53 19.6599 24.58 19.7499 24.62C19.6299 24.55 19.5199 24.47 19.4099 24.39C19.4099 24.39 19.4099 24.39 19.3999 24.39L19.4099 24.4C19.4299 24.42 19.4599 24.44 19.4899 24.46Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M10.7199 25.32C10.3399 25.27 9.96986 25.18 9.62986 25.06C9.61986 25.06 9.61986 25.06 9.60986 25.06"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M22.8598 25.67C22.8698 25.67 22.8898 25.67 22.8998 25.67H22.9098C22.8798 25.67 22.8498 25.67 22.8198 25.67C22.8298 25.67 22.8398 25.67 22.8598 25.67ZM22.8598 25.67C22.8498 25.67 22.8498 25.67 22.8598 25.67Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M25.6701 25.38C25.7101 25.37 25.7401 25.35 25.7701 25.34C25.7001 25.36 25.6301 25.38 25.5601 25.4C25.6001 25.39 25.6301 25.39 25.6701 25.38Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M22.8301 25.67C22.6701 25.66 22.5201 25.63 22.3701 25.61C22.4001 25.61 22.4201 25.62 22.4501 25.63C22.5801 25.64 22.7001 25.65 22.8301 25.67Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M26.1999 25.19C26.1799 25.2 26.1499 25.21 26.1299 25.22C26.1499 25.21 26.1699 25.2 26.1999 25.19Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M16.8501 18.89C16.9501 18.82 17.0501 18.76 17.1601 18.7C17.0501 18.76 16.9501 18.83 16.8501 18.89Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M16.5601 19.11C16.6101 19.07 16.6501 19.04 16.7001 19"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M17.1602 18.71C17.2702 18.65 17.3702 18.61 17.4802 18.57C17.3702 18.6 17.2602 18.65 17.1602 18.71Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M17.81 18.47C17.72 18.49 17.63 18.51 17.54 18.55C17.64 18.51 17.73 18.49 17.81 18.47Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M16.3003 19.33C16.3203 19.31 16.3403 19.29 16.3603 19.27C16.3403 19.3 16.3203 19.31 16.3003 19.33Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M16.5103 22.88C16.5103 22.88 17.1003 22.75 17.7303 22.85"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M21.4301 11.79C21.3901 12.03 21.1801 12.16 21.0801 12.22C20.6901 12.46 20.0701 12.43 19.8401 11.99C19.8301 11.96 19.7001 11.72 19.7701 11.44C19.8901 10.98 20.4601 10.74 20.8901 10.93C21.1901 11.06 21.5001 11.45 21.4301 11.79Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
      <path
        d="M14.8998 11.54C14.8598 11.78 14.6498 11.91 14.5498 11.97C14.1598 12.21 13.5398 12.18 13.3098 11.74C13.2998 11.71 13.1698 11.47 13.2398 11.19C13.3598 10.73 13.9298 10.49 14.3598 10.68C14.6598 10.81 14.9598 11.19 14.8998 11.54Z"
        stroke="currentColor"
        strokeMiterlimit={10}
      />
    </svg>
  );
}
export default SvgLunch;
